/**
 * HubSpot OAuth Callback Page
 *
 * Receives the authorization code from HubSpot OAuth redirect,
 * sends it back to the opener window via postMessage, and closes.
 */

import { useEffect, useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';

export const Route = createFileRoute('/_authenticated/connectors/hubspot/callback')({
  component: HubspotCallbackPage,
});

function HubspotCallbackPage() {
  const [noOpener, setNoOpener] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'hubspot-oauth-callback',
          code,
          state,
          error: error || undefined,
        },
        window.location.origin,
      );
      window.close();
    } else {
      setNoOpener(true);
    }
  }, []);

  if (noOpener) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-muted-foreground text-sm">
          This window can be closed. Please return to the main app.
        </p>
      </div>
    );
  }

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex items-center gap-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Completing connection...</span>
      </div>
    </div>
  );
}
